export enum ELoginActions {
  LOGIN_REQUEST = 'login/LOGIN_REQUEST',
  LOGIN_SUCCESS = 'login/LOGIN_SUCCESS',
  LOGIN_FAIL = 'login/LOGIN_FAIL',

  LOGOUT_REQUEST = 'login/LOGOUT_REQUEST',
  LOGOUT_SUCCESS = 'login/LOGOUT_SUCCESS',
  LOGOUT_FAIL = 'login/LOGOUT_FAIL',
}
